export const getPoster = (
  thumbnails: {
    width: number;
    source: string;
  }[],
  containerWidth: number
): string | undefined => {
  let poster: string | undefined = undefined;

  // default thumbnail
  if (thumbnails.length > 0) {
    poster = thumbnails[thumbnails.length - 1].source;
  }

  if (containerWidth) {
    thumbnails?.forEach((thumbnail) => {
      if (!poster || thumbnail.width > containerWidth) {
        poster = thumbnail.source;
      }
    });
  }

  return poster ?? undefined;
};
